import React from 'react';

export const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-2xl'
  };

  return (
    <div className={`${className}`}>
      <span 
        className={`${sizes[size]} font-medium tracking-[0.3em] text-gray-900`}
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        JUPITER
      </span>
    </div>
  );
};
